
import Link from "next/link";
import { useState } from "react";
import { usePathname, useRouter } from "next/navigation";
import { signIn } from "next-auth/react";
import { MdOutlineVisibilityOff, MdOutlineVisibility } from "react-icons/md";
import { PrimaryBtn } from "@/components/elements/Buttons";
import React from "react";
// import Image from "next/image";
import { useDialog } from "@/utils/DialogProvider";
import { useTranslation } from "react-i18next";
import { isValidEmail } from "@/utils/fncts";
import { useDrawer } from "@/utils/DrawerProvider";
import { ResetPasswordDialog } from "@/app/[locale]/login/loginPage";
import SignUpDrawer from "../drawers/signupdrawer";

export const LoginDialog = ({ drawerid }: { drawerid?: string }) => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const pathname = usePathname();

  const [loginError, setLoginError] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const { t, i18n } = useTranslation();
  const currentLocale = i18n.language as "ar" | "fr" | "en";
  const { closeDialog, openDialog } = useDialog();
  const { closeDrawer, openDrawer } = useDrawer();
  const handleLogin = async () => {
    if (!isValidEmail(formData.email)) {
      setLoginError(true);
      return { error: true };
    }
    try {
      const response = await signIn("credentials", {
        email: formData.email.replace(/\s/g, ""),
        password: formData.password,
        redirect: false,
      });
      if (response!.status == 401) {
        console.error(response?.error);
        setLoginError(true);
        return { error: true };
      }
      closeDialog();
      closeDrawer(drawerid ?? "");
      return { success: true };
    } catch (error) {
      console.error(error);
      setLoginError(true);
      return { error: true };
    }
  };

  return (
    <div className=" login transparent-bg">
      <div></div>
      <div className="grid gap20">
        <div>
          <h2 className="fw800">{t("login")} </h2>
          <p className="secondary-color">{t("loginToContinue")}</p>
        </div>
        <div>
          <label htmlFor="">{t("email")}</label>
          <input
            className={"grey-bg"}
            type="text"
            id="email"
            name="email"
            required
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
          />
        </div>
        <div>
          <label htmlFor="">{t("password")}</label>
          <div className="relative">
            <input
              className={"grey-bg"}
              type={isPasswordVisible ? "text" : "password"}
              id="password"
              name="password"
              required
              value={formData.password}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
            />

            <span
              className="password-toggle"
              style={{
                right: currentLocale == "ar" ? "" : "10px",
                left: currentLocale == "ar" ? "10px" : "",
              }}
              onClick={() => setIsPasswordVisible(!isPasswordVisible)}
            >
              {isPasswordVisible ? (
                <MdOutlineVisibilityOff />
              ) : (
                <MdOutlineVisibility />
              )}
            </span>
          </div>
          {loginError && (
            <p className="red f13">{t("incorrectEmailOrPassword")}</p>
          )}
          <p
            className=" f13 dark-grey pointer"
            onClick={() => {
              openDialog(t("forgotPassword"), <ResetPasswordDialog />);
            }}
          >
            {t("forgotPassword")}
          </p>
        </div>

        <PrimaryBtn text={t("login")} submit={handleLogin} />

        {pathname.includes("signup") ? (
          <Link
            href="/signup"
            className="tcenter"
            onClick={() => {
              closeDialog();
              closeDrawer(drawerid ?? "");
            }}
          >
            {" "}
            <h3 className="dark-grey">{t("createAccount")} </h3>
          </Link>
        ) : (
          <div
            className="tcenter pointer"
            onClick={() => {
              closeDialog();
              closeDrawer(drawerid ?? "");
              openDrawer({
                id: "signup",
                content: <SignUpDrawer />,
                title: t("createAccount"),
              });
            }}
          >
            {" "}
            <h3 className="dark-grey">{t("createAccount")} </h3>
          </div>
        )}
      </div>
      <div></div>
    </div>
  );
};
